import { render, staticRenderFns } from "./DonorNotification.vue?vue&type=template&id=0cb35ee2&"
import script from "./DonorNotification.vue?vue&type=script&lang=js&"
export * from "./DonorNotification.vue?vue&type=script&lang=js&"
import style0 from "./DonorNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports